import React from 'react';
import { datePropTypes } from './DatePropTypes';
import * as styles from './Date.module.scss';
const Date = ({
  label,
  datetime,
  date
}) => {
  if (!label && !date && !datetime) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootLabel
  }, label), /*#__PURE__*/React.createElement("time", {
    dateTime: datetime,
    className: styles.rootDate
  }, date));
};
export default Date;